<template>
  <div class="floating-widget-preview">
    <!-- Container to simulate store page -->
    <div
      class="preview-container relative min-h-[400px] bg-gray-100 rounded-lg p-4"
      :style="cssProps"
    >
      <!-- Floating Widget -->
      <div v-if="reviewMeta.locationName">
        <div id="carthike-review-badge-wrapper">
          <div
            class="inline-flex flex-col bg-white py-1 px-3 rounded-md border border-gray-300 carthike-floating-badge-wrapper"
          >
            <div class="flex items-center space-x-1">
              <div class="flex-shrink-0">
                <svg
                  class="w-5 h-5"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    fill="#4285F4"
                  ></path>
                  <path
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    fill="#34A853"
                  ></path>
                  <path
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    fill="#FBBC05"
                  ></path>
                  <path
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    fill="#EA4335"
                  ></path>
                </svg>
              </div>
              <div class="text-2xl font-bold mx-2">4.9</div>
              <div class="text-sm floating-badge-star-container">
                <div class=" text-sm">
                  {{
                    Array(Math.floor(reviewMeta.averageRating))
                      .fill("★")
                      .join("")
                  }}<span class="">{{
                    reviewMeta.averageRating % 1 >= 0.5 ? "★" : ""
                  }}</span>
                  <span
                    >{{
                      Array(5 - Math.ceil(reviewMeta.averageRating))
                        .fill("☆")
                        .join("")
                    }}
                  </span>
                </div>
              </div>
            </div>
            <div class="text-xs font-medium text-center opacity-75">
              {{ reviewMeta.totalReviewCount }} Reviews
            </div>
          </div>
        </div>
      </div>

      <!-- Preview Content -->
      <div class="text-center text-gray-500 mt-4">
        <p class="text-sm">
          This is how the floating widget will appear on your store
        </p>
        <p class="text-xs mt-2">
          The widget will be fixed to the {{ config.position }} side of the
          screen
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reviewMeta: {},
      defaultReviewMeta: {
        newReviewUri: "https://google.com",
        averageRating: 4.599999904632568,
        totalReviewCount: 14,
        locationName: "Sample Company"
      }
    };
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    cssProps() {
      return {
        "--floating-badge-card-background-color": `${this.config.badgeConfig.cardBackgroundColor}`,
        "--floating-badge-stars-color": `${this.config.badgeConfig.starColor}`,
        "--floating-badge-text-color": `${this.config.badgeConfig.textColor}`
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const store = this.$store.getters.getStore;
      this.$store
        .dispatch("getPublicReviews", { shop: store.shopOrigin })
        .then(response => {
          if (response.reviewMeta) {
            this.reviewMeta = response.reviewMeta;
          } else {
            this.reviewMeta = this.defaultReviewMeta;
          }
        });
    }
  }
};
</script>

<style scoped>
.preview-container {
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.carthike-floating-badge-wrapper {
  background: var(--floating-badge-card-background-color);
  color: var(--floating-badge-text-color);
}
.floating-badge-star-container {
  color: var(--floating-badge-stars-color);
}
</style>
